<div class="app-wrapper" [class.nav-open]="sidebarService.sidebarOpen">
    <router-outlet></router-outlet>
</div>
<div class="lazy-loading-container" *ngIf="lazyLoading">
    <span class="fas fa-spin fa-spinner fa-fw fa-4x"></span>
    <!-- <app-loading-state [messages]="['Getting everything ready...']"></app-loading-state> -->
</div>